var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0201384615 0.0124029586 7.27187574 0.0124029586 7.27187574 7.24253314 0.0201384615 7.24253314"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0.297789458%",
    x2: "0%",
    y2: "99.7022105%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "3.57373565e-16 0.0455680473 16.9286805 0.0455680473 16.9286805 16.9580281 3.57373565e-16 16.9580281"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0.0954734517%",
    x2: "0%",
    y2: "99.9045265%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B1FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2979FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v2",
    transform: "translate(-831.000000, -361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(831.000000, 361.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(9.656805, 9.812420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28016213,1.73664556 C5.73244024,1.73664556 5.28832781,2.1805568 5.28832781,2.7282787 L5.28832781,3.04383491 L2.25699645,0.0124029586 L0.0201384615,2.24936154 L3.0298426,5.25916627 L2.75754083,5.25916627 C2.20981893,5.25916627 1.76570651,5.70307751 1.76570651,6.2509 C1.76570651,6.79862189 2.20981893,7.24253314 2.75754083,7.24253314 L6.28016213,7.24253314 C6.82778343,7.24253314 7.27189586,6.79862189 7.27189586,6.2509 L7.27189586,2.7282787 C7.27189586,2.1805568 6.82778343,1.73664556 6.28016213,1.73664556",
    id: "Fill-1",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 0.055024)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6693609,8.5255 L14.945213,4.24964793 L14.945213,4.55987278 C14.945213,5.10749408 15.3891243,5.5517071 15.9368462,5.5517071 C16.4847692,5.5517071 16.9286805,5.10749408 16.9286805,4.55987278 L16.9286805,1.03735207 C16.9286805,0.489529586 16.4847692,0.0455177515 15.9368462,0.0455177515 L12.414426,0.0455177515 C11.8666036,0.0455177515 11.4225917,0.489529586 11.4225917,1.03735207 C11.4225917,1.58507396 11.8666036,2.0290858 12.414426,2.0290858 L12.6920592,2.0290858 L8.43260355,6.28864201 L8.43250296,6.28864201 L6.19564497,8.52539941 L6.19564497,8.5255 L0.461414201,14.2598314 C-0.153804734,14.8749497 -0.153804734,15.881571 0.461414201,16.4966893 C1.07653254,17.1118077 2.08305325,17.1118077 2.6981716,16.4966893 L8.43260355,10.7622574 L8.43270414,10.762358 L10.6694615,8.52560059 L10.6693609,8.5255 Z",
    id: "Fill-4",
    fill: "url(#linearGradient-6)",
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.95144615,7.33619408 L7.18820355,5.09933609 L2.71116805,0.622300592 C2.0960497,0.00728284024 1.0894284,0.00728284024 0.474310059,0.622300592 C-0.140707692,1.23741893 -0.140707692,2.24404024 0.474310059,2.85915858 L4.95144615,7.33619408 Z",
    id: "Fill-7",
    fill: "url(#linearGradient-7)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0c36a15a12f60061c4479ac91aa1ab18.svg";
export { ForwardRef as ReactComponent };